export const GET_INVESTORS_FILES = 'investors/GET_FILES';



// WEBPACK FOOTER //
// ./src/redux/InvestorSection/constants.js